if (window.customElements && !customElements.get('sale-countdown')) {
  class SaleCountdown extends HTMLElement {
    constructor() {
      super();
      const endDateStr = this.dataset.endDate;
      const endTimeStr = this.dataset.endTime;
      const endOffset = this.dataset.endOffset || '-04:00';
      const endISO = endDateStr + 'T' + endTimeStr + ':00' + endOffset;
      const endTime = new Date(endISO).getTime();
      if (isNaN(endTime)) return;

      this.selectors = {
        daysWrap: this.querySelector('[data-countdown-days-wrap]'),
        days: this.querySelector('[data-countdown-days]'),
        hours: this.querySelector('[data-countdown-hours]'),
        minutes: this.querySelector('[data-countdown-minutes]'),
        seconds: this.querySelector('[data-countdown-seconds]')
      };

      this.options = {
        countdownInterval: 1000,
        label: this.dataset.label || '',
        endTime: endTime,
      };

      this.tickCountdowns();
      this.interval = setInterval(() => this.tickCountdowns(), this.options.countdownInterval);
    }

    tickCountdowns() {
      const remaining = Math.max(0, Math.floor((this.options.endTime - Date.now()) / 1000));
      const totalHours = Math.floor(remaining / 3600);
      const showDays = totalHours > 24;

      if (this.selectors.daysWrap) {
        this.selectors.daysWrap.classList.toggle('is-hidden', !showDays);
        const separator = this.selectors.daysWrap.nextElementSibling;
        if (separator && separator.classList.contains('sale-countdown-separator')) {
          separator.classList.toggle('is-hidden', !showDays);
        }
      }

      if (showDays) {
        if (this.selectors.days) this.selectors.days.textContent = this.pad(Math.floor(remaining / 86400));
        this.selectors.hours.textContent = this.pad(Math.floor((remaining % 86400) / 3600));
      } else {
        this.selectors.hours.textContent = this.pad(totalHours);
      }

      this.selectors.minutes.textContent = this.pad(Math.floor((remaining % 3600) / 60));
      this.selectors.seconds.textContent = this.pad(remaining % 60);
    }

    pad(n) { return n < 10 ? '0' + n : '' + n; }
  }

  customElements.define('sale-countdown', SaleCountdown);
}